
<template>
  <div>
    <Grid
      :service="service"
      defaultOrderColumn="created_date_formatted"
      defaultOrderDirection="asc"
      route_name="privacy_form"
      :ref="'grid'"
      :css_formats="{
        validated_date_formatted: (name, model) => {
          if(name){
            return `badge badge-glow badge-${model.status_label_validated}`
          }else{
            return ''
          }
        }
      }"
    >
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`privacy_form.handling`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Tratar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="handling(actions.row.id)"/>
          <feather-icon
            v-permission="`privacy_form.detail`"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>
            <feather-icon
              v-permission="`privacy_form.delete`"
              icon="Trash2Icon"
              class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
              v-tooltip.top="{
                content: 'Excluir formulário',
                delay: { show: 100, hide: 100 }
              }"
              @click="actions.methods.destroy(actions.data[actions.indextr])"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import PrivacyFormHandlingService from '@/services/api/PrivacyFormHandlingService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    handling(id) {
      this.$router.push(`/privacy-form/${id}/handling`)
    },
    detail(id) {
      this.$router.push(`/privacy-form/${id}`)
    }
  },
  beforeMount() {
    this.service = PrivacyFormHandlingService.build(this.$vs)
  }
}
</script>
